import { DOCUMENT } from '@angular/common';
import { effect, inject, Injectable } from '@angular/core';
import { ITenantConfigResponse } from '@inshuwa-client/models';
import { DarkModeService } from './dark-mode.service';
import { computeThemeProperties, resolveFaviconHref } from './theme-applier.utils';

@Injectable({ providedIn: 'root' })
export class ThemeApplierService {
  private readonly document = inject(DOCUMENT);
  private readonly darkMode = inject(DarkModeService);
  private config: ITenantConfigResponse | null = null;

  constructor() {
    effect(() => {
      const dark = this.darkMode.isDark();
      if (this.config) this.applyProperties(this.config, dark);
    });
  }

  apply(config: ITenantConfigResponse): void {
    this.config = config;
    this.applyProperties(config, this.darkMode.isDark());

    const faviconHref = resolveFaviconHref(config);
    if (faviconHref) {
      this.document.getElementById('appFavicon')?.setAttribute('href', faviconHref);
    }

    this.document.title = config.portalName;
  }

  private applyProperties(config: ITenantConfigResponse, dark: boolean): void {
    const root = this.document.documentElement.style;
    for (const [key, value] of Object.entries(computeThemeProperties(config, dark))) {
      root.setProperty(key, value);
    }
  }
}
